<template>
  <div :id="content.idHTML" class="TODO:" :class="jel_getClassObject(content)">
    <EditableArea
      v-if="mixinEnvironnement_inEditor"
      :content="content.catfish"
      :parentTemplateId="metadata['mgnl:template']"
    />
    <Catfish v-else-if="contentCatfish" :content="contentCatfish"></Catfish>
  </div>
</template>

<script>
import { EditableArea } from '@/vue-editor';
import Catfish from '@/components/base/Catfish';
import { mixinEnvironnement } from '@/mixins/mixinEnvironnement';

export default {
  name: 'ListeCatfish',
  components: { EditableArea, Catfish },
  mixins: [mixinEnvironnement],
  props: { metadata: { type: Object, required: true }, content: { type: Object, required: true } },
  computed: {
    contentCatfish() {
      // On cherche le premier Catfish à afficher, null si aucun
      const aNodeTrouve = this.content.catfish['@nodes'].find((aNode) => {
        return this.jel_isComponentVisible(this.content.catfish[aNode]);
      });
      return aNodeTrouve ? this.content.catfish[aNodeTrouve] : null;
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.jel_setCookieAffichage(this.content); // nextTick obligatoire
    });
  },
};
</script>

<style lang="scss" scoped></style>
